// eslint-disable-next-line no-control-regex -- intentionally matches C0 controls and DEL
const CONTROL_CHARS = /[\u0000-\u001F\u007F]/

// Same-origin path only: rejects absolute URLs, scheme URIs, `//x`, `/\x` and control chars (browsers strip TAB/CR/LF, so `/\t/x` acts as `//x`)
export const isSafePath = (value: string): boolean =>
  value.startsWith('/') &&
  value[1] !== '/' &&
  value[1] !== '\\' &&
  !CONTROL_CHARS.test(value)

// Returns `redirect_url` from the query string when it passes isSafePath, otherwise null
export const getSafeRedirectUrl = (search: string): string | null => {
  const raw = new URLSearchParams(search).get('redirect_url')
  return raw && isSafePath(raw) ? raw : null
}

export default getSafeRedirectUrl
